<template lang="pug">
validation-observer.analise(ref='validation' tag='div')
  el-card(shadow='hover' v-if="processo && processo.id").card-collapse
    el-col(:span='8').center
      app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
      app-display(label="Número do processo:", :content="processo.numeroProcesso")
    el-col(:span='8')
      app-display(label="CPF do Interessado:", :content="processo.cpfCnpjInteressado")
      app-display(label="Tipo de Processo:", :content="processo.tipo.nome")
    app-opcoes-header-analise.right(
      :idProcesso="processo.id"
      :numeroProcesso="processo.numeroProcesso"
      :protocolo="processo.numeroProtocolo"
      :tipoProcesso="processo.tipo.codigo"
      :btnSolicitarInformacao="true"
      :btnRetificacao="false"
    )
  el-card(shadow="hover",v-if="this.active === 0 && processo && processo.id && (vtnExcedente || processo.tipo.codigo === 'ONEROSO' || processo.tipo.codigo === 'CERTIDAO_TITULO')").card-collapse
    app-radios-tramitacao(
      :radios="acaoParaEmissaoOuDespachoVtn",
      :isDecisao="true",
      @changeRadio="changeRadioDespacho",
      :radioInicial="action",
    )
  el-card(shadow="hover",v-if="!isDespacho && processo && processo.id").card-container
    div
      el-steps.margin-top(:active='active', finish-status='success', simple)
        el-step(title='Dados do VTN')
        el-step(v-show="!vtnExcedente", title='Dados da custas')
        el-step(title='Confirmar dados')

      validation-observer(ref='validation' tag='div', v-if="active === 0")

        el-row.mb-20(type="flex", :gutter="40")
          el-col()
            dados-vtn(
              v-if="processo.numeroProcesso"
              :numeroProcesso="processo.numeroProcesso"
              :tipoProcesso="tipoProcesso"
              :vtnExcedente="vtnExcedente"
            )
      div(v-if="active === 1")
        custas-vtn
      div(v-if="active === 2")
        app-dados-calculo-vtn(:dadosVtn="dadosVtn", :tipoProcesso="tipoProcesso", :resumo="true", :calculoExcedente="vtnExcedente")
    app-buttons-cadastro(
      :isUltimoPasso="active > 1",
      :isPrimeiroPasso="active === 0",
      :showButtonCancelar="active === 0"
      :showButtonProximo="active < 2"
      @proximo="proximo"
      @voltar="voltar"
      @finalizar="finalizar",
      @cancelar="cancelar"
    )
  el-card(shadow="hover",v-if="processo && processo.id && isDespacho").card-container
    validation-observer.analise(ref='validation' tag='div')
      validation-provider(rules="required", v-slot="{ errors }")
        el-alert.alert(
          v-if="vtnExcedente"
          title="Ao encaminhar para o próximo setor, não haverá alteração no VTN já existente."
          type="warning"
          show-icon,
          :closable="false"
        )
        app-label.input-text-editor(label="Despacho")
        app-editor-texto.input(
          @onTextChange="onTextChange",
          v-model="despacho.textoDespacho",
          :class="{'erro' : errors.length}"
          ref="editorTexto"
        )
        span.help.erro {{ errors[0] }}
      app-anexo(
        :id="'upload-anexo-despacho'",
        @uploadFile="uploadFile",
        :files="despacho.documentos",
        @removeFile="removeFile"
        @downloadDocumentoCadastro="downloadDocumentoCadastro",
        :tipoExibir="'ANEXO_ANALISE'"
      )
      app-radios-tramitacao(
        :radios="acoesRadioDespacho",
        :isDecisao="false",
        @changeRadio="changeRadio",
        :radioInicial="despacho.acao",
      )
      app-buttons-cadastro(
        :isUltimoPasso="false",
        :isPrimeiroPasso="true",
        :showButtonCancelar="active === 0"
        :showButtonProximo="false"
        :isDespacho="despacho.acao != null"
        @proximo="proximo"
        @voltar="voltar"
        @finalizar="finalizarDespacho",
        @cancelar="cancelar"
      )

</template>
<script>

import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import FileSaver from 'file-saver'
import DadosVtn from '@/screens/financeiro/vtn/DadosVtn'
import AppOpcoesHeaderAnalise from './components/modal/AppOpcoesHeaderAnalise'
import AppEditorTexto from '@/components/AppEditorTexto'
import CustasVtn from '@/components/CustasVtn'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppDadosCalculoVtn from '@/components/AppDadosCalculoVtn'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDisplay from '@/components/AppDisplay'
import AppLabel from '@/components/AppLabel'
import AppAnexo from '@/components/AppAnexo'
import { mapActions } from 'vuex'
import axios from '@/utils/api'
const {acaoEmissaoVtn, getAcao} = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default {
  beforeDestroy: function () {
    this.$store.commit('vtn/CLEAR_VTN')
  },
  beforeCreate: function () {
    this.$store.commit('vtn/CLEAR_VTN')
  },
  components: {
    DadosVtn,
    AppOpcoesHeaderAnalise,
    AppButtonsCadastro,
    CustasVtn,
    AppDadosCalculoVtn,
    AppDisplay,
    AppRadiosTramitacao,
    AppEditorTexto,
    AppLabel,
    AppAnexo,
    FileSaver
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    protocolo: {
      required: true
    }
  },

  data () {
    return {
      showModal: false,
      active: 0,
      custasAgrarias: 0,
      processo: null,
      dadosVtn: null,
      vtnExcedente: true,
      acaoParaEmissaoOuDespachoVtn: acaoEmissaoVtn,
      action: 'EMITIR',
      tipo: 'FINALIZAR.CPAV.GERAR_VTN',
      cartas: null,
      despacho: {
        textoDespacho: ''
      },
      acoesRadio: [],
      radios: [],
      getAcao: getAcao,
      acoesRadioDespacho: []
    }
  },

  async created () {
    this.processo = await this.getProcessoById(this.idProcesso)
    this.tipoProcesso = this.processo?.tipo?.codigo
    this.getVtn()
    this.iniciaEmissao()
  },

  computed: {
    isEmissao () {
      return this.action === 'EMITIR'
    },

    isDespacho () {
      return this.action === 'DESPACHO'
    },

    getAcoes () {
      return this.getAcao(this.despacho, this.acoesRadio, this.action)
    }
  },

  methods: {
    ...mapActions({
      getProcessoById: 'processo/getProcessoById',
      iniciaAnalise: 'processo/iniciaAnalise',
      tarefa: 'processo/tarefa'
    }),

    voltar () {
      this.getVtn()
      if (this.vtnExcedente) {
        this.active = 0
      } else {
        this.active--
      }
    },

    uploadFile (file) {
      this.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.id === documento.id)
        )
        this.despacho.documentos.splice(index, 1)
      } else {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.key === documento.key)
        )
        this.despacho.documentos.splice(index, 1)
      }
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    onTextChange (text) {
      this.despacho.textoDespacho = text
    },

    changeRadioDespacho (value) {
      this.action = value.acao
    },

    async iniciaEmissao () {
      const response = await this.iniciaAnalise({
        idProcesso: this.processo.id,
        tipoAcao: this.tipo
      })
      this.cartas = response.despacho.anexosCarta

      this.setDespachoVazio(response)

      this.dadosCadastro = response.setores
      this.radios = await this.tarefa({ processo: this.processo.id })
      this.acoesRadioDespacho = this.radios.acoes
        .filter(action => action.valor !== 'AGUARDANDO_CONFIRMACAO_INTERESSADO.SISTEMA.CPAV')
        .filter(this.vtnExcedente ? action => action.valor === 'FINALIZAR.CPAV.GERAR_VTN' : action => action.valor !== 'FINALIZAR.CPAV.GERAR_VTN')
    },

    setDespachoVazio (response) {
      if (response.despacho.status !== 'FINALIZADO') {
        this.despacho = response.despacho
      } else {
        this.despacho = {
          ...response.despacho,
          textoDespacho: '',
          documentos: [],
          processo: response.despacho.processo,
          id: null,
          numeroDaCertidao: null,
          tituloDespacho: { tituloProcesso: null, tituloProcessoDTO: {} }
        }
      }
    },

    async getVtn () {
      this.dadosVtn = await axios({
        method: 'GET',
        url: `financeiro/vtn/findByIdProcesso/${this.idProcesso}`
      })
      if (this.dadosVtn) {
        if (this.dadosVtn.excedente) {
          this.vtnExcedente = true
        } else {
          this.vtnExcedente = false
        }
        if (this.dadosVtn.calculosVtn &&
            this.dadosVtn.calculosVtn.resumoParcelaExcedente &&
            this.dadosVtn.calculosVtn.resumoParcelaExcedente[0] &&
            this.dadosVtn.calculosVtn.resumoParcelaExcedente[0].areaExcedente
        ) {
          this.dadosVtn.areaRequerida = this.dadosVtn.calculosVtn.resumoParcelaExcedente[0].areaExcedente
        }
        this.$store.commit('vtn/SET_VTN', {...this.dadosVtn})
      } else {
        this.vtnExcedente = false
        this.$store.commit('vtn/SET_PARCELAS', await axios({
          url: `financeiro/vtn/parcelas/processo/${this.idProcesso}`,
          method: 'GET'
        }))
        this.custasAgrarias = await axios({
          method: 'GET',
          url: `financeiro/custasAgrarias/calcularValor/${this.idProcesso}`
        })
        this.$store.commit(`vtn/SET_FIELD_VALUE`, { field: 'custasAgrarias', value: this.custasAgrarias })
      }
    },

    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },

    async proximo () {
      if (this.active === 0 && !await this.checkValidacao()) {
        return
      }
      if (this.active === 0 && this.vtnExcedente) {
        this.active += 2
      } else {
        this.active++
      }
      if (this.active > 0) {
        this.dadosVtn = {...this.$store.state.vtn.dadosVtn}
        this.dadosVtn.processoSicarf = this.processo
        this.dadosVtn.numeroProcesso = this.processo.numeroProcesso

        this.criarOuAtualizarVtn()
      }
    },

    cancelar () {
      this.$router.push({
        name: 'CAIXA_AGUARDANDO_VTN'
      }
      )
    },

    async finalizar () {
      const data = {tipoConversaEnum: 'NOTIFICACAO_FORMA_PAGAMENTO'}
      try {
        await axios({
          method: 'post',
          data: data,
          url: `financeiro/vtn/finalizarEmissaoVtn/${this.idProcesso}`
        })
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Análise finalizada.')
        this.$router.back()
      } catch (err) {
        const erroValidacao = err.status === 422
        if (!erroValidacao) {
          this.showNotificacao('error', 'Erro!', 'Ocorreu um erro, tente novamente mais tarde.')
        }
      }
    },

    async criarOuAtualizarVtn () {
      try {
        this.dadosVtn = await axios({
          method: 'POST',
          url: `financeiro/vtn/excedente`,
          data: this.dadosVtn
        })
        this.$store.commit('vtn/SET_VTN', {...this.dadosVtn})
        this.showNotificacao('success', 'Sucesso!', 'VTN salva com sucesso.')
      } catch (err) {
        this.showNotificacao('error', 'Erro!', 'Ocorreu um erro, tente novamente mais tarde.')
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    changeRadio (value) {
      this.despacho.acao = value.acao
    },

    async finalizarDespacho () {
      if (this.isDespacho && !await this.checkValidacao()) {
        return
      }
      this.confirmBox(
        this.$messages.MSG_CONFIRMACAO,
        this.$messages.TITULO_WARNING,
        async () => {
          try {
            if (this.action === 'DESPACHO') {
              await axios({
                method: 'post',
                url: 'despacho/finalizar/semVTN',
                data: {
                  ...this.despacho,
                  idProcesso: this.idProcesso
                }
              })
            } else {
              await axios({
                method: 'post',
                url: `financeiro/vtn/tramitarEmissaoTitulo/${this.dadosVtn.id}/${this.despacho.acao}`,
                data: this.despacho
              })
            }
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Análise finalizada.')
            this.$router.back()
          } catch (err) {
            this.showNotificacao('error', 'Erro!', 'Ocorreu um erro, tente novamente mais tarde.')
          }
        }
      )
    }
  }
}

</script>
<style>
.label {
  font-weight: bold;
}

.opcoes {
  margin-bottom: 40px;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.alert {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/CalcularVtn.vue